import { Languages } from "src/common/descriptions/types";
import { CreateServiceCategoryDescriptions } from "./types";

const DescriptionsEnUs: CreateServiceCategoryDescriptions = {
    EDIT_TITLE: "Edit Service Category",
    TITLE: "Create Service Category",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save Service Category?',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Service Category input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Service Category Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Service Updated",
    },
    FORM: {
        NAME: {
            LABEL: "Name",
            PLACEHOLDER: "Input pervice name",
        },
        IS_ACTIVE: {
            LABEL: "Status",
            PLACEHOLDER: "Select status",
        },
    },
    MAIN_ACTION_TITLE: "Creating Service Category",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
}

const DescriptionsEsUs: CreateServiceCategoryDescriptions = {
    EDIT_TITLE: "Editar Categoría de Servicio",
    TITLE: "Crear Categoría de Servicio",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Categoría de Servicio con los datos ingresados?',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Categoría de Servicio?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Categoría de Servicio creada",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Servicio Actualizado",
    },
    FORM: {
        NAME: {
            LABEL: "Nombre",
            PLACEHOLDER: "Ingrese nombre",
        },
        IS_ACTIVE: {
            LABEL: "Estado",
            PLACEHOLDER: "Seleccione estado",
        },
    },
    MAIN_ACTION_TITLE: "Creando Categoría de Servicio",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
}

export const createServiceCategoryDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}